import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import SrDarkModal from 'client/components/SrDarkModal';
import SrButton, {
  SR_BUTTON_THEME_ADOBE_GREEN,
} from 'client/components/SrButton/SrButton';

const SrSelfShowingInstallationSuccessModal = ({ handleComplete, listingPhoto, text }) => {
  return (
    <SrDarkModal>
      <div
        className={classnames(
          'SrListingSelfTouringSection sunlockStatusModal sunlockLockForm',
        )}
        onClick={(event) => event.stopPropagation()}
      >
        <SrFlex
          width='100%'
          justify='center'
          marginBottom='18px'
        >
          <img
            src={listingPhoto}
            alt='Listing'
            width='207px'
            height='120px'
            style={{ borderRadius: 8 }}
          />
        </SrFlex>
        <SrFlex
          direction='col'
          justify='center'
        >
          <SrText
            color='blueGreycliff'
            font='greycliff'
            weight='800'
            fontSize='21px'
            lineHeight='30px'
            align='center'
          >
            {text}
          </SrText>
          <div className='divider' />
        </SrFlex>
        <SrFlex
          direction='col'
          marginBottom='16px'
          justify='center'
        >
          <SrBox
            marginTop='82px'
          >
            <SrButton
              onClick={handleComplete}
              theme={SR_BUTTON_THEME_ADOBE_GREEN}
            >
              Continue
            </SrButton>
          </SrBox>
        </SrFlex>
      </div>
    </SrDarkModal>
  );
};

SrSelfShowingInstallationSuccessModal.propTypes = {
  handleComplete: PropTypes.func.isRequired,
  listingPhoto: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default SrSelfShowingInstallationSuccessModal;
